// @ts-check

import React from 'react';
import { func } from 'prop-types';
import Button from '@mui/material/Button';

/**
 * @component ProfileEditorBtns
 * @param {Object} props
 * @param {()=>Promise<void>} props.onUpdate
 * @param {()=>void} props.onReset
 * @param {boolean} props.canNotSave
 * @returns {JSX.Element}
 */
function ProfileEditorBtns({ onUpdate, onReset, canNotSave }) {
	return (
		<section
			style={{ display: 'flex', gap: '1rem', padding: '0rem 0rem', justifyContent: 'flex-end' }}
		>
			<Button variant="contained" onClick={onReset} sx={{ width: '6rem' }}>
				RESET
			</Button>
			<Button variant="contained" disabled={canNotSave} onClick={onUpdate} sx={{ width: '6rem' }}>
				SAVE
			</Button>
		</section>
	);
}

ProfileEditorBtns.propTypes = { onUpdate: func, onReset: func };

export default ProfileEditorBtns;
